import { opCfg, opMemberUserId } from './config.js';
import { openPaymentSelectedUserId } from './dom.js';
import { renderSavedCards, setSavedCardsDisabled } from '../../shared/saved-card-picker.js';

const SAVED_CARDS_PICKER = 'open_payment_saved_payment_id';

export const savedPaymentsState = { cache: {}, inFlight: {}, hasSavedCards: false };

export function resetSavedPaymentsState() {
    savedPaymentsState.cache = {};
    savedPaymentsState.inFlight = {};
    savedPaymentsState.hasSavedCards = false;
}

export function setOpenPaymentSavedCards(cards) {
    renderSavedCards(SAVED_CARDS_PICKER, cards);
    setSavedCardsDisabled(SAVED_CARDS_PICKER, false);
}

export function clearOpenPaymentSavedCards() {
    renderSavedCards(SAVED_CARDS_PICKER, []);
    setSavedCardsDisabled(SAVED_CARDS_PICKER, true);
}

function openPaymentSavedPaymentsUrl(uid) {
    const template = String(opCfg().savedPaymentsUrlTemplate || '');
    return template.replace(':user_id', String(uid));
}

export function fetchOpenPaymentSavedPayments(uid) {
    const key = String(uid || '');
    if (!key) {
        return $.Deferred().resolve({ success: false, saved_cards: [] }).promise();
    }
    if (savedPaymentsState.cache[key]) {
        return $.Deferred().resolve(savedPaymentsState.cache[key]).promise();
    }
    if (savedPaymentsState.inFlight[key]) {
        return savedPaymentsState.inFlight[key];
    }

    const req = $.getJSON(openPaymentSavedPaymentsUrl(key))
        .then(function (res) {
            const normalized = (res && res.success)
                ? { success: true, saved_cards: res.saved_cards || [] }
                : { success: false, saved_cards: [] };
            savedPaymentsState.cache[key] = normalized;
            return normalized;
        })
        .catch(function (err) {
            console.error('Failed to fetch saved payments for user', key, err);
            const normalized = { success: false, saved_cards: [] };
            savedPaymentsState.cache[key] = normalized;
            return normalized;
        })
        .always(function () {
            delete savedPaymentsState.inFlight[key];
        });

    savedPaymentsState.inFlight[key] = req;
    return req;
}

export function seedOpenPaymentSavedPaymentsFromConfig() {
    const muid = opMemberUserId() || openPaymentSelectedUserId();
    if (!muid) {
        return null;
    }
    const cards = Array.isArray(opCfg().prefetchedSavedCards)
        ? opCfg().prefetchedSavedCards
        : null;
    if (cards === null || cards.length === 0) {
        return null;
    }
    savedPaymentsState.cache[String(muid)] = {
        success: true,
        saved_cards: cards,
    };
    return cards;
}
